import React from "react";

const EulaPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <header className="bg-blue-600 text-white p-4 text-center">
        <h1 className="text-xl font-bold">
          End User License Agreement / اتفاقية ترخيص المستخدم النهائي
        </h1>
      </header>

      <main className="container mx-auto mt-8 p-4 bg-white rounded shadow-lg">
        {/* Introduction Section */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            Introduction / المقدمة
          </h2>
          <p className="mb-2">
            This Licensed Application End User License Agreement ("Standard
            EULA") is a binding agreement between you and Tarbaa (the
            "Application Provider"). This Standard EULA governs your use of the
            Tarbaa application and any related services or features ("Licensed
            Application").
            <br />
            <br />
            Apps made available through the App Store are licensed, not sold, to
            you. Your license to the App is subject to your prior acceptance of
            this Standard EULA. The Application Provider reserves all rights in
            and to the Licensed Application not expressly granted to you under
            this Standard EULA.
            <br />
            <br />
            هذه الاتفاقية ("الاتفاقية القياسية") هي اتفاقية ملزمة بينك وبين
            ترَبَّع ("مزود التطبيق"). تحكم هذه الاتفاقية استخدامك لتطبيق ترَبَّع
            وأي خدمات أو ميزات ذات صلة ("التطبيق المرخص").
            <br />
            <br />
            التطبيقات المتاحة عبر متجر التطبيقات مرخصة، وليست مباعة، لك. يخضع
            ترخيصك للتطبيق لقبولك المسبق لهذه الاتفاقية القياسية. يحتفظ مزود
            التطبيق بجميع الحقوق في التطبيق المرخص ولا يمنحك صراحة بموجب هذه
            الاتفاقية.
          </p>
        </section>

        {/* Scope of License */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            Scope of License / نطاق الترخيص
          </h2>
          <p className="mb-2">
            The Application Provider grants you a nontransferable license to use
            the Licensed Application on any Apple-branded products that you own
            or control and as permitted by the Usage Rules. You may not
            distribute or make the Licensed Application available over a network
            where it could be used by multiple devices at the same time. You may
            not transfer, redistribute or sublicense the Licensed Application.
            <br />
            <br />
            You may not copy, reverse-engineer, disassemble, attempt to derive
            the source code of, modify, or create derivative works of the
            Licensed Application, any updates, or any part thereof (except as
            permitted by applicable law).
            <br />
            <br />
            يمنحك مزود التطبيق ترخيصًا غير قابل للتحويل لاستخدام التطبيق المرخص
            على أي منتجات تحمل علامة Apple تملكها أو تتحكم فيها وكما تسمح به
            قواعد الاستخدام. لا يجوز لك توزيع أو إتاحة التطبيق المرخص عبر شبكة
            حيث يمكن استخدامه بواسطة أجهزة متعددة في نفس الوقت. لا يجوز لك نقل
            أو إعادة توزيع أو ترخيص التطبيق المرخص من الباطن.
            <br />
            <br />
            لا يجوز لك نسخ أو إجراء هندسة عكسية أو تفكيك أو محاولة اشتقاق الكود
            المصدري أو تعديل أو إنشاء أعمال مشتقة من التطبيق المرخص أو أي
            تحديثات أو أي جزء منه (إلا بما يسمح به القانون المعمول به).
          </p>
        </section>

        {/* Subscription Information */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            Auto-Renewable Subscriptions / الاشتراكات التي تتجدد تلقائيًا
          </h2>
          <p className="mb-2">
            Our app offers auto-renewable subscriptions. Payment will be charged
            to your Apple ID account at confirmation of purchase. Subscriptions
            automatically renew unless auto-renew is turned off at least
            24-hours before the end of the current period. Your account will be
            charged for renewal within 24-hours prior to the end of the current
            period. Subscriptions may be managed and auto-renewal may be turned
            off by going to your Account Settings after purchase.
            <br />
            <br />
            يقدم تطبيقنا اشتراكات تتجدد تلقائيًا. سيتم خصم الدفع من حساب Apple
            ID الخاص بك عند تأكيد الشراء. تتجدد الاشتراكات تلقائيًا ما لم يتم
            إيقاف التجديد التلقائي قبل 24 ساعة على الأقل من نهاية الفترة
            الحالية. سيتم خصم رسوم التجديد من حسابك خلال 24 ساعة قبل نهاية
            الفترة الحالية. يمكن إدارة الاشتراكات وإيقاف التجديد التلقائي من
            خلال الذهاب إلى إعدادات الحساب بعد الشراء.
          </p>
        </section>

        {/* Consent to Use of Data */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            Consent to Use of Data / الموافقة على استخدام البيانات
          </h2>
          <p className="mb-2">
            You agree that the Application Provider may collect and use
            technical data and related information—including but not limited to
            technical information about your device, system and application
            software, and peripherals—that is gathered periodically to
            facilitate the provision of software updates, product support, and
            other services to you related to the Licensed Application. The
            Application Provider may use this information, as long as it is in a
            form that does not personally identify you, to improve its products
            or to provide services or technologies to you.
            <br />
            <br />
            أنت توافق على أن مزود التطبيق قد يجمع ويستخدم البيانات التقنية
            والمعلومات ذات الصلة - بما في ذلك على سبيل المثال لا الحصر المعلومات
            التقنية حول جهازك ونظامك وبرامج التطبيق والملحقات - التي يتم جمعها
            بشكل دوري لتسهيل توفير تحديثات البرامج ودعم المنتج والخدمات الأخرى
            المقدمة لك والمتعلقة بالتطبيق المرخص. قد يستخدم مزود التطبيق هذه
            المعلومات، طالما أنها في شكل لا يحدد هويتك شخصيًا، لتحسين منتجاته أو
            لتقديم خدمات أو تقنيات لك.
          </p>
        </section>

        {/* Termination */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">Termination / الإنهاء</h2>
          <p className="mb-2">
            This Standard EULA is effective until terminated by you or the
            Application Provider. Your rights under this Standard EULA will
            terminate automatically if you fail to comply with any of its terms.
            <br />
            <br />
            هذه الاتفاقية القياسية سارية المفعول حتى يتم إنهاؤها من قبلك أو من
            قبل مزود التطبيق. ستنتهي حقوقك بموجب هذه الاتفاقية القياسية تلقائيًا
            إذا فشلت في الامتثال لأي من شروطها.
          </p>
        </section>

        {/* External Services */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            External Services / الخدمات الخارجية
          </h2>
          <p className="mb-2">
            The Licensed Application may enable access to the Application
            Provider's and/or third-party services and websites. You agree to
            use the External Services at your sole risk. The Application
            Provider is not responsible for examining or evaluating the content
            or accuracy of any third-party External Services, and shall not be
            liable for any such third-party External Services.
            <br />
            <br />
            قد يتيح التطبيق المرخص الوصول إلى خدمات ومواقع ويب تابعة لمزود
            التطبيق و/أو جهات خارجية. أنت توافق على استخدام الخدمات الخارجية على
            مسؤوليتك الخاصة. مزود التطبيق غير مسؤول عن فحص أو تقييم محتوى أو دقة
            أي خدمات خارجية تابعة لجهات خارجية، ولن يكون مسؤولاً عن أي خدمات
            خارجية تابعة لجهات خارجية.
          </p>
        </section>

        {/* Warranty Disclaimer */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            No Warranty / لا ضمانات
          </h2>
          <p className="mb-2">
            YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE LICENSED
            APPLICATION IS AT YOUR SOLE RISK. TO THE MAXIMUM EXTENT PERMITTED BY
            APPLICABLE LAW, THE LICENSED APPLICATION AND ANY SERVICES PERFORMED
            OR PROVIDED BY THE LICENSED APPLICATION ARE PROVIDED "AS IS" AND "AS
            AVAILABLE," WITH ALL FAULTS AND WITHOUT WARRANTY OF ANY KIND. THE
            APPLICATION PROVIDER HEREBY DISCLAIMS ALL WARRANTIES AND CONDITIONS
            WITH RESPECT TO THE LICENSED APPLICATION AND ANY SERVICES, EITHER
            EXPRESS, IMPLIED, OR STATUTORY.
            <br />
            <br />
            أنت تقر صراحةً وتوافق على أن استخدام التطبيق المرخص يكون على
            مسؤوليتك الخاصة. إلى أقصى حد يسمح به القانون المعمول به، يتم توفير
            التطبيق المرخص وأي خدمات يتم تنفيذها أو تقديمها بواسطة التطبيق
            المرخص "كما هي" و"كما هي متاحة"، مع جميع العيوب ودون أي ضمان من أي
            نوع. يخلي مزود التطبيق بموجب هذا مسؤوليته عن جميع الضمانات والشروط
            المتعلقة بالتطبيق المرخص وأي خدمات، سواء كانت صريحة أو ضمنية أو
            قانونية.
          </p>
        </section>

        {/* Limitation of Liability */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            Limitation of Liability / تحديد المسؤولية
          </h2>
          <p className="mb-2">
            TO THE EXTENT NOT PROHIBITED BY LAW, IN NO EVENT SHALL THE
            APPLICATION PROVIDER BE LIABLE FOR PERSONAL INJURY OR ANY
            INCIDENTAL, SPECIAL, INDIRECT, OR CONSEQUENTIAL DAMAGES WHATSOEVER,
            INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF PROFITS, LOSS OF
            DATA, BUSINESS INTERRUPTION, OR ANY OTHER COMMERCIAL DAMAGES OR
            LOSSES. IN NO EVENT SHALL THE APPLICATION PROVIDER'S TOTAL LIABILITY
            TO YOU FOR ALL DAMAGES EXCEED THE AMOUNT OF FIFTY DOLLARS ($50.00).
            <br />
            <br />
            إلى الحد الذي لا يحظره القانون، لن يكون مزود التطبيق مسؤولاً بأي حال
            من الأحوال عن الإصابات الشخصية أو أي أضرار عرضية أو خاصة أو غير
            مباشرة أو تبعية مهما كانت، بما في ذلك، على سبيل المثال لا الحصر،
            الأضرار الناتجة عن فقدان الأرباح أو فقدان البيانات أو انقطاع الأعمال
            أو أي أضرار أو خسائر تجارية أخرى. لن تتجاوز المسؤولية الإجمالية
            لمزود التطبيق تجاهك عن جميع الأضرار مبلغ خمسين دولارًا (50.00
            دولار).
          </p>
        </section>

        {/* Governing Law */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            Governing Law / القانون الحاكم
          </h2>
          <p className="mb-2">
            This Agreement and the relationship between you and the Application
            Provider shall be governed by the laws of the State of California,
            excluding its conflicts of law provisions. If you are a citizen of
            any European Union country or Switzerland, Norway or Iceland, the
            governing law and forum shall be the laws and courts of your usual
            place of residence.
            <br />
            <br />
            تخضع هذه الاتفاقية والعلاقة بينك وبين مزود التطبيق لقوانين ولاية
            كاليفورنيا، باستثناء أحكام تعارض القوانين. إذا كنت مواطنًا في أي
            دولة من دول الاتحاد الأوروبي أو سويسرا أو النرويج أو أيسلندا، فإن
            القانون الحاكم والمنتدى سيكون قوانين ومحاكم مكان إقامتك المعتاد.
          </p>
        </section>

        {/* Contact Section */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">Contact Us / اتصل بنا</h2>
          <p className="mb-2">
            If you have any questions about this End User License Agreement,
            please contact us at tarbaa.kw@gmail.com.
            <br />
            <br />
            إذا كان لديك أي أسئلة حول اتفاقية ترخيص المستخدم النهائي هذه، يرجى
            الاتصال بنا على tarbaa.kw@gmail.com.
          </p>
        </section>

        {/* Last Updated Section */}
        <section className="mt-8 text-gray-600">
          <p>Last Updated: Apr 2025 / آخر تحديث: ابريل 2025</p>
        </section>
      </main>

      <footer className="bg-gray-800 text-white text-center p-4 mt-8">
        <p>© 2025 ترَبَّع. All rights reserved. / جميع الحقوق محفوظة.</p>
        <div className="mt-2">
          <a
            href="https://www.tarbaa.com/privacy"
            className="text-blue-300 hover:underline mx-2"
          >
            Privacy Policy
          </a>
          <a
            href="https://www.tarbaa.com/terms"
            className="text-blue-300 hover:underline mx-2"
          >
            Terms of Use
          </a>
        </div>
      </footer>
    </div>
  );
};

export default EulaPage;
